import { Menu } from '../models/menu.model';

export const MENU: Array<Menu> = [
  {
    icon: 'dashboard',
    route: '/dashboard',
    title: 'Dashboard',
  },
  {
    icon: 'group',
    route: 'users',
    title: 'Usuarios',
  },
  // {
  //   icon: 'business',
  //   route: '/companies',
  //   title: 'Compañias',
  // },
];

export const BRANCH_MENU: Array<Menu> = [
  {
    icon: 'dashboard',
    route: '/branches/:idBranch',
    title: 'Dashboard',
  },
  {
    icon: 'directions_car',
    route: '/branches/:idBranch/orders',
    title: 'Ordenes',
  },
  {
    icon: 'receipt_long',
    route: '/branches/:idBranch/quotations',
    title: 'Cotizaciones',
  },
  // {
  //   icon: 'engineering',
  //   route: '/branches/:idBranch/board',
  //   title: 'Seguimiento',
  // },
  {
    icon: 'account_balance_wallet',
    route: '/branches/:idBranch/movements',
    title: 'Movimientos',
  },
  {
    icon: 'people',
    route: '/branches/:idBranch/clients',
    title: 'Clientes',
  },
  {
    icon: 'storage',
    route: '/branches/:idBranch/storage',
    title: 'Inventario',
  },
  {
    icon: 'warehouse',
    route: '/branches/:idBranch/warehouse',
    title: 'Almacén',
  },
  {
    icon: 'forklift',
    route: '/branches/:idBranch/suppliers',
    title: 'Proveedores',
  },
  {
    icon: 'people',
    route: '/branches/:idBranch/staff',
    title: 'Empleados',
  },
  {
    icon: 'security',
    title: 'Seguridad',
    children: [
      {
        route: 'security/modules',
        title: 'Módulos',
      },
      {
        route: 'security/roles',
        title: 'Roles',
      },
      {
        route: 'security/staff',
        title: 'Usuarios',
      },
    ]
  },
  {
    icon: 'category',
    title: 'Catálogos',
    children: [
      {
        route: 'catalogues/indicators',
        title: 'Indicadores',
      },
      {
        route: 'catalogues/stock',
        title: 'Inventario',
      },
      {
        route: 'catalogues/platforms',
        title: 'Plataformas',
      },
    ]
  },
  {
    icon: 'settings',
    title: 'Configuraciones',
    children: [
      {
        route: 'checklists',
        title: 'Datos de la sucursal',
      },
      {
        route: 'status-workflows',
        title: 'Workflow',
      }
    ]
  },
];
